module.exports = __webpack_public_path__ + "img/bdyx.9afe4351.png";